function compareNoCase(s1: string, s2: string) {
  return s1 && s2 ? s1.toLowerCase() === s2.toLowerCase() : s1 === s2;
}

type Args = {
  textQuery: string;
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line typescript/no-explicit-any
  addressData: Record<string, any>;
};

export async function lookupAddress({ textQuery, addressData }: Args) {
  const { Geocoder } = (await google.maps.importLibrary(
    'geocoding',
  )) as google.maps.GeocodingLibrary;

  // oxlint-disable-next-line typescript/no-explicit-any
  return new Promise<Record<string, any>>((resolve) => {
    new Geocoder().geocode(
      {
        address: textQuery,
        componentRestrictions: {
          country: addressData.country ?? [],
        },
      },
      // oxlint-disable-next-line typescript/no-explicit-any
      (results: any) => {
        // prevent results that could have come back later from overriding this.
        const update = {};

        if (results && results.length > 0) {
          const [result] = results;

          if (['US', 'CA'].includes(addressData.country)) {
            const stateComponent = result.address_components.find(
              // oxlint-disable-next-line typescript/no-explicit-any
              (c: any) => c.types.includes('administrative_area_level_1'),
            );

            if (
              stateComponent &&
              (compareNoCase(stateComponent.long_name, addressData.state) ||
                compareNoCase(stateComponent.short_name, addressData.state))
            ) {
              // Only update the address if there is a valid state / province
              // @ts-expect-error TS(2339): Property 'stateCode' does not exist on type '{}'.
              update.stateCode = stateComponent.short_name;
              // @ts-expect-error TS(2339): Property 'latitude' does not exist on type '{}'.
              update.latitude = result.geometry.location.lat();
              // @ts-expect-error TS(2339): Property 'longitude' does not exist on type '{}'.
              update.longitude = result.geometry.location.lng();
              // @ts-expect-error TS(2339): Property 'latLongAddress' does not exist on type '... Remove this comment to see the full error message
              update.latLongAddress = result.formatted_address;
              // @ts-expect-error TS(2339): Property 'full' does not exist on type '{}'.
              update.full = result.formatted_address;
            }
          } else {
            // @ts-expect-error TS(2339): Property 'latitude' does not exist on type '{}'.
            update.latitude = result.geometry.location.lat();
            // @ts-expect-error TS(2339): Property 'longitude' does not exist on type '{}'.
            update.longitude = result.geometry.location.lng();
            // @ts-expect-error TS(2339): Property 'latLongAddress' does not exist on type '... Remove this comment to see the full error message
            update.latLongAddress = result.formatted_address;
            // @ts-expect-error TS(2339): Property 'full' does not exist on type '{}'.
            update.full = result.formatted_address;
          }
        }

        resolve(update);
      },
    );
  });
}
